export default __webpack_public_path__ + "static/media/stareRating.4f7da6b4.svg";